import resolveFilterType from '@/components/query/helpers/resolve-filter-type';
import FilterSet from '@/components/query/filter-set';

const getGroupAndField = (rawPath) => {
    const path = rawPath.slice(1);
    const steps = path.split(FilterSet.delimiter);
    const ancestors = steps.slice(0, steps.length - 1);
    return {
        fieldName: steps[steps.length - 1],
        group: `${FilterSet.delimiter}${ancestors.join(FilterSet.delimiter)}`,
        steps,
    };
};

/**
 * Nested fields are not present at the root of the groups
 * so we look for it in reverse from the full path.
 * @param fieldName
 */
const reverseLookup = ({fieldName, steps, groups}) => {
    let notFound = true;
    let end = steps.length - 1;
    let group;
    while (notFound) {
        group = `${FilterSet.delimiter}${steps.slice(0, end).join(FilterSet.delimiter)}`;
        if (Reflect.has(groups, group)) {
            notFound = false;
        } else if (end <= 1) {
            notFound = false;
        } else {
            end -= 1;
        }
    }
    if (Reflect.has(groups[group].fields, fieldName)) {
        return {...groups[group].fields[fieldName]};
    }
    const levels = steps.slice(end);
    return {
        ...levels.reduce((result, level) => {
            result = result[level];
            return result;
        }, groups[group].fields),
    };
};

/**
 * Cache resource field definitions to speed up their processing.
 * @type {{}}
 */
const resourceFieldCache = {};

/**
 * Find the resource field represented by the criteria
 * condition path provided.
 * @param {string} path
 * @param {object} groups
 * @returns {{field: {}, type: string}}
 */
export default function getResourceField(path, groups) {
    // check in cache first
    if (Reflect.has(resourceFieldCache, path)) {
        return resourceFieldCache[path];
    }
    const {group, fieldName, steps} = getGroupAndField(path);
    let field;
    if (Reflect.has(groups, group)) {
        field = {...groups[group].fields[fieldName]};
    } else {
        field = reverseLookup({fieldName, steps, groups});
    }
    const cached = {
        field,
        type: resolveFilterType(field),
    };
    // save to cache
    Reflect.set(resourceFieldCache, path, cached);
    return cached;
}
